import React from 'react';
import PdfCuentaBancaria from './PdfCuentaBancaria';
import PdfVencimiento from './PdfVencimiento';
import { useTerminologia } from '../../hooks/useTerminologia';

const PdfInfoUtil = ({ vencimiento, juicios }) => {
    const t = useTerminologia();
    return (
        <>
            <div className="pdf-section-title">INFORMACIÓN UTIL</div>

            <PdfCuentaBancaria />

            <PdfVencimiento fecha={vencimiento} />

            <div className="pdf-paragraph">
                Las expensas se encuentran disponibles en la sección "Expensas" de SimpleSolutions
            </div>
            <div className="pdf-paragraph">
                Les recordamos que en la sección "Documentos" de SimpleSolutions podrán encontrar
                los reglamentos del {t.barrio} y otra información
            </div>

            <div className="pdf-block-title">Atencion al Consorcista:</div>
            <div className="pdf-paragraph">
                Para realizar consultas les recordamos que se encuentra habilitada la sección
                "consultas" en Simple Solutions.<br />
                Por consultas referidas a expensas comunicarse por whatsapp al 11-2885-9979
                o por mail expensas@admzaputovich.com
            </div>

            <div className="pdf-block-title">Emergencias:</div>
            <div className="pdf-paragraph">
                Los llamados fuera del horario de atención son exclusivamente por urgencia
            </div>
            <table className="pdf-emergencias-tabla">
                <tbody>
                    <tr>
                        <td>Vanina</td>
                        <td>11-4071-5453</td>
                        <td><a href="mailto:vanina@admzaputovich.com">vanina@admzaputovich.com</a></td>
                    </tr>
                    <tr>
                        <td>Nicolas</td>
                        <td>11-4192-9008</td>
                        <td><a href="mailto:nicolas@admzaputovich.com">nicolas@admzaputovich.com</a></td>
                    </tr>
                </tbody>
            </table>

            <div className="pdf-block-title">Aviso por mora en el pago:</div>
            <div className="pdf-paragraph">
                Se informa a los copropietarios que {t.esEdificio ? 'todo aquel departamento' : 'toda aquella unidad funcional'} que se encuentre
                en Mora por el pago de Expensas en un plazo mayor a 90 días será derivada a un
                Estudio Jurídico a los fines de su pronta cobranza. Una vez derivado al Estudio
                Jurídico el copropietario deberá abonar gastos y honorarios derivados de la
                gestión de cobranzas de forma particular.
            </div>

            <div className="pdf-block-title">Juicios del Consorcio:</div>
            <div className="pdf-paragraph">
                {juicios || 'El consorcio no posee Juicios en curso'}
            </div>
        </>
    );
};

export default PdfInfoUtil;
